import logo from "../../images/works2.png"


export default function WorksTitle() {
  return (
    <img className="works" src={logo} alt="contact logo" />
   
  );
}